import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Media Queries/prefers-color-scheme";
import * as React from 'react';
export default {
  Content,
  React
};